// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductBadge{position:absolute;top:8px;right:5px;z-index:10;text-transform:uppercase;font-size:14px;padding:2px 6px}.ProductBadge--pre-order{background:#10bcbe}.ProductBadge--funding{background:#9257e0}@media(min-width:768px){.ProductBadge{top:16px;right:-10px;font-size:20px;padding:4px 12px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
